import BvImpersonateWidget from '@bv/components/impersonate-widget/BvImpersonateWidget.vue';
import { WidgetInjector } from '@bv/utils/widget-injector';

type Props = any;

/**
 * Singleton instance of the WidgetInjector, specifically for managing the BvImpersonateWidget.
 *
 * This manager is pre-configured to inject and control the {@link BvImpersonateWidget}
 * component, mounting it into a DOM element.
 *
 * widget's lifecycle (e.g., `initWidget`, `updateProps`, `destroyWidget`).
 *
 * @type {WidgetInjector<Props>}
 */
export const impersonateWidget: WidgetInjector<Props> = new WidgetInjector<Props>(BvImpersonateWidget);

export default impersonateWidget;
